// src/context/AuthContext.js v1.7
import React, { createContext, useContext, useState, useEffect } from 'react';
import { authenticateUser, openShift, getOpenShift, initDB, startPolling, stopPolling } from '../database/db';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [shift, setShift] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('ps_current_user');
    if (saved) {
      try {
        const u = JSON.parse(saved);
        setUser(u);
        setShift(getOpenShift(u.id) || null);
      } catch {}
    }
    // Sync all data from server on load + start 5s polling
    initDB().catch(() => {});
    startPolling();
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const result = await authenticateUser(username, password);
    if (!result) return { success: false, error: 'Cannot connect to server. Check internet.' };
    if (result.locked) return { success: false, error: result.error || 'Account locked.', locked: true };
    if (result.id) {
      setUser(result);
      localStorage.setItem('ps_current_user', JSON.stringify(result));
      // Open shift
      try { const sh = await openShift(result.id, result.name); setShift(sh); } catch {}
      return { success: true, user: result };
    }
    return { success: false, error: 'Invalid credentials' };
  };

  const logout = () => {
    stopPolling();
    setUser(null);
    setShift(null);
    localStorage.removeItem('ps_current_user');
  };

  const refreshShift = async () => {
    if (user) setShift(getOpenShift(user.id) || null);
  };

  return (
    <AuthContext.Provider value={{ user, shift, loading, login, logout, refreshShift }}>
      {children}
    </AuthContext.Provider>
  );
};
